import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import updateProductQuantityOperation from 'store/product/operation/updateProductQuantityOperation';
import getProductQuantity from 'store/product/selector/getProductQuantity';
import { setInitialProductQuantityAction, setProductQuantityAction } from 'store/product/slice';
import styles from './QuantitySelector.module.scss';

const QuantitySelector = () => {
  const dispatch = useDispatch();
  const currentQuantity = useSelector(getProductQuantity);
  const [quantity, setQuantity] = useState(1);

  const incQuantity = () => {
    setQuantity(Math.min(quantity + 1, 99));
  };

  const decQuantity = () => {
    setQuantity(Math.max(quantity - 1, 1));
  };

  useEffect(() => {
    dispatch(setInitialProductQuantityAction(currentQuantity));
    setQuantity(currentQuantity);
  }, []);

  useEffect(() => {
    dispatch(setProductQuantityAction(quantity));
    dispatch(updateProductQuantityOperation());
  }, [quantity]);

  return (
    <div className={styles.quantitySelector}>
      <div className={styles.btn} onClick={decQuantity} id="checkout-popup-quantity-reduce">
        -
      </div>
      <div className={styles.quantity}>{quantity}</div>
      <div className={styles.btn} onClick={incQuantity} id="checkout-popup-quantity-add">
        +
      </div>
    </div>
  );
};

export default QuantitySelector;
